var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2 18.3332C1.45 18.3332 0.979167 18.1292 0.5875 17.7212C0.195833 17.3132 0 16.8228 0 16.2498V3.74984C0 3.17692 0.195833 2.68647 0.5875 2.27848C0.979167 1.8705 1.45 1.6665 2 1.6665H18C18.55 1.6665 19.0208 1.8705 19.4125 2.27848C19.8042 2.68647 20 3.17692 20 3.74984V16.2498C20 16.8228 19.8042 17.3132 19.4125 17.7212C19.0208 18.1292 18.55 18.3332 18 18.3332H2ZM10 11.0415L18 5.83317V3.74984L10 8.95817L2 3.74984V5.83317L10 11.0415Z",
    fill: "#00A3FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.707a1dc0930e3eba4fc56174e1af9ddb.svg";
export { ForwardRef as ReactComponent };